<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
          <v-card-title class="primary white--text title">
              {{'Add Dates'|translate}}
          </v-card-title>
          <v-card-text>
              <date-range-selector v-model="range"></date-range-selector>

              <v-text-field
                      :label="'Type'|translate"
                      v-model="date_type"
              ></v-text-field>
              <v-textarea :label="'Notes'|translate" v-model="notes">
              </v-textarea>

          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord()" :disabled="!$can('update', 'Dates')">{{'Save'|translate}}</v-btn>
              <v-btn @click="dialog=false">{{'Cancel'|translate}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {putDates} from '../helper'
  import DateRangeSelector from "./DateRangeSelector";
  import moment from 'moment'
  export default {
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
      components:{DateRangeSelector},
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.date_id = item['date_id']
            this.range = {start: item['start_date'], end: item['end_date']}
          this.notes= item['notes']
          this.date_type= item['date_type']
        }
      },
      value () {
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
          if(!this.dialog){
              this.initializeVar()
          }
      }
    },
    data () {
      return {
          dialog: false,
          date_id: null,
          range: null,
          notes: null,
          date_type: null,
      }
    },
    methods: {
      initializeVar() {
        this.date_id= null
        this.notes= null
        this.date_type= null
        this.range={start: moment().subtract(7, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')}
      },
      async addRecord () {
          let payload={
              'date_id': this.date_id,
              'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
              'start_date': this.range.start,
              'end_date': this.range.end,
              'notes': this.notes,
              'date_type': this.date_type,
          }
          await putDates(
              payload
          )
          this.$emit('doreload')
          this.dialog=false
      }
    },
    name: 'DatesDialog'
  }
</script>

<style scoped>

</style>
